import * as Yup from "yup";

export const getAdminValidationSchema = (t) =>
   Yup.object().shape({
      name: Yup.string()
         .min(3, t("min-3-symbols-validation"))
         .max(50, t("max-50-symbols-validation"))
         .required(t("name-required-validation")),

      phoneNumber: Yup.string()
         .min(3, t("min-3-symbols-validation"))
         .max(50, t("max-50-symbols-validation"))
         .required(t("phone-number-required-validation"))
   });

export const getNgoValidationSchema = (t) =>
   Yup.object().shape({
      organizationName: Yup.string()
         .min(3, t("min-3-symbols-validation"))
         .max(50, t("max-50-symbols-validation"))
         .required(t("name-required-validation")),
      organizationEmail: Yup.string()
         .email(t("invalid-organization-email-validation"))
         .required(t("organization-email-required-validation")),
      baseCountryId: Yup.string()
         .nullable()
         .required(t("base-country-required-validation")),
      cityId: Yup.string().nullable(),
      // .required(t("city-required-validation")),
      address: Yup.string().required(t("organization-address-required-validation"))
   });

// wait till fixed from backend
export const getNgoMemberValidationSchema = (t) =>
   Yup.object().shape({
      name: Yup.string()
         .min(3, t("min-3-symbols-validation"))
         .max(50, t("max-50-symbols-validation"))
         .required(t("name-required-validation")),
      // birthday: Yup.string().required("Birthday is required"),
      gender: Yup.string().required(t("gender-required-validation"))
   });

export const getDonorValidationSchema = (t) =>
   Yup.object().shape({
      name: Yup.string()
         .min(3, t("min-3-symbols-validation"))
         .max(50, t("max-50-symbols-validation"))
         .required(t("name-required-validation")),
      baseCountryId: Yup.string()
         .nullable()
         .required(t("base-country-required-validation"))
   });

export const getHumanitarianValidationSchema = (t) =>
   Yup.object().shape({
      name: Yup.string()
         .min(3, t("min-3-symbols-validation"))
         .max(50, t("max-50-symbols-validation"))
         .required(t("name-required-validation")),
      // baseCountryId: Yup.string()
      //    .nullable()
      //    .required("Base country is required"),
      // personalStatement: Yup.string().required("Personal statement is required"),
      residenceCountryId: Yup.string().required(t("name-required-validation")),
      operatingCountriesIds: Yup.string()
         .min(1, t("at-least-one-country-required-validation"))
         .required(t("operating-countries-required-validation")),
      // HigestDegree: Yup.object()
      //    .shape({
      //       value: Yup.string().required("Degree value is required"), // Validate the `value` property
      //       label: Yup.string().required("Degree label is required") // Validate the `label` property
      //    })
      //    .nullable()
      //    .required("Highest degree is required"),
      Expertises: Yup.array().of(
         Yup.object().shape({
            areaName: Yup.string().required(t("area-required-validation")),
            areaExperienceYears: Yup.number()
               .required(t("years-of-experience-required-validation"))
               .typeError(t("years-of-experience-number-validation"))
         })
      ),

      Languages: Yup.array().of(
         Yup.object({
            languageId: Yup.string().required(t("language-required-validation")),
            level: Yup.number()
               .required(t("level-required-validation"))
               .typeError(t("level-number-validation"))
         })
      )
   });
